import { isArray } from '_utils/functions';

/**
 * Gets the answer to an id
 * @param {*} survey 
 * @param {*} qID 
 */

export const getAnswer = (answers, qID) => {
  const answer = answers.find(q => q.qID == qID);

  return answer?.answer;
}

/**
 * Checks a survey object to see if conditions are met
 * @param {Survey} survey 
 * @param {Array<Condition>} conditions typeof Condition: {"id": "example_id", "values": ["example_value"]}
 * @returns 
 */

export const checkSurvey = (survey, conditions) => {
    let conditions_met = true;

    conditions.forEach(req => { //TODO: Implement boolean options ("or", "and", ?: { "nor?", "not?" })
        const requirement = survey.find(q => q.qID == req.id)?.answer;

        if (isArray(requirement)) {
          conditions_met = requirement.some(opt => req.values.includes(opt));
        } else if (!req.values.includes(requirement)) {
          conditions_met = false;
        }
    })

    return conditions_met;
}

/**
 * Filters visible components
 * @param {Components} comps 
 * @returns 
 */

export const filterVisibleComponents = (answers, comps) => {
  return comps.filter(c => {
    if (!c.conditional) {
      return true;
    }

    return checkSurvey(answers, c.conditional_requirements);
  })
}

/**
 * Filters visible routes
 * @param {Routes} routes 
 * @returns 
 */

export const filterVisibleRoutes = (answers, routes) => {
  return routes.filter(r => {
    if (!r.conditional) {
      return true;
    }

    return checkSurvey(answers, r.conditional_requirements);
  })
}

/**
 * Calculates current survey progress
 * @param {*} index 
 * @param {*} length 
 * @returns 
 */

export const calculateProgress = (index, length) => {
  if (index == 0) {
    return 0;
  }
  return Math.max(Math.floor(index / length * 100), 1);
}